/** SliderJoint3D property surface. A key stays `undefined` when unauthored, so the consumer applies Godot's default. */
/** `params[PARAM_LINEAR_LIMIT_UPPER] = 1.0` in slider_joint_3d.cpp:125. */
const DEFAULT_LINEAR_UPPER = 1;
/** `params[PARAM_LINEAR_LIMIT_LOWER] = -1.0` in slider_joint_3d.cpp:126. */
const DEFAULT_LINEAR_LOWER = -1;
/** `params[PARAM_ANGULAR_LIMIT_UPPER]` and `params[PARAM_ANGULAR_LIMIT_LOWER]` in slider_joint_3d.cpp:136-137. */
const DEFAULT_ANGULAR_LIMIT = 0;
/** The limits the gizmo draws: each authored key, else Godot's default. */
export function drawnLimits(properties) {
    return {
        linearLower: properties['linear_limit/lower_distance'] ?? DEFAULT_LINEAR_LOWER,
        linearUpper: properties['linear_limit/upper_distance'] ?? DEFAULT_LINEAR_UPPER,
        angularLower: properties['angular_limit/lower_angle'] ?? DEFAULT_ANGULAR_LIMIT,
        angularUpper: properties['angular_limit/upper_angle'] ?? DEFAULT_ANGULAR_LIMIT,
    };
}
//# sourceMappingURL=types.js.map